module.exports = __webpack_public_path__ + "img/id.1ea00815.svg";